import React from "react";
import { Box, Grid2, Typography } from "@mui/material";

const BasicDetails = ({ tender }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year} ${time}`;
  };
  return (
    <div>
      <Box className="dashboard-container" px={10}>
        <Typography className="form-title">1. Tender Details</Typography>
        <Grid2 container>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000" }}
          >
            Tender ID
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000", borderRight: "1px solid #000" }}
          >
            {tender && tender.tenderId}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Title
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{
              borderRight: "1px solid #000",
            }}
          >
            {tender && tender.title}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Short Description
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.shortDesc}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Long Description
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.longDesc}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Tender Purchase Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDate(tender.tenderPurchaseDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Tender Publish Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDate(tender.tenderPublishDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Bid Submission Start Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDateTime(tender.bidSubmissionStartDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Bid Submission End Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDateTime(tender.bidSubmissionEndDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Bid Opening Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDateTime(tender.bidOpeningDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Bid Offer Validity (From End Date) (In Days)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.bidOfferValidity}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Department Name
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.deptName}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Contact Person Email
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.contactEmail}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Item Category
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.itemCategory}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Contract Period (In Months)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.contractPeriod}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Documents required from seller
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.sellerDoc}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Type of Tender
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.type}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Time allowed for Technical Clarifications (in days)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.technicalExpiry}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Estimated Bid Value (in &#8377;)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.bidValue !== undefined
              ? new Intl.NumberFormat("en-IN", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(tender.bidValue)
              : "-"}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Evaluation Method
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.evalMethod}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Arbitration Clause
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.arbitrationClause ? "Yes" : "No"}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Mediation Clause
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.mediationClause ? "Yes" : "No"}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Is this a single bid tender?
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.isSingleBid ? "Yes" : "No"}
          </Grid2>
        </Grid2>
      </Box>
    </div>
  );
};

export default BasicDetails;
